import SidebarBrand from "./SidebarBrand";
import SidebarNavItem from "./SidebarNavItem";
import SidebarDropdown from "./SidebarDropdown";
import SidebarPropertyNav from "./SidebarPropertyNav";
import SidebarUserCard from "./SidebarUserCard";
import { navigationSections } from "../../../config/menu";
import { canAccessItem } from "../../../services/accessControl";
import styles from "./Sidebar.module.css";

const Sidebar = ({
  isCollapsed,
  onToggleCollapse,
  mobileOpen,
  onCloseMobile,
  authUser,
  settings,
  onOpenProfile,
  onLogoutClick,
  propertyContext = null,
}) => {
  // Filter sections and items based on role and app settings permissions
  const visibleSections = navigationSections
    .map((sec) => {
      // Check if user has access to section itself
      const hasSectionAccess = canAccessItem(sec, settings);
      if (!hasSectionAccess && sec.roles?.length) {
        return null;
      }

      // Filter visible items within section
      const visibleItems = sec.items.filter((item) =>
        canAccessItem(item, settings)
      );

      if (visibleItems.length === 0) {
        return null;
      }

      return {
        ...sec,
        items: visibleItems,
      };
    })
    .filter(Boolean);

  const sidebarClasses = [
    styles.sidebar,
    mobileOpen ? styles.sidebarOpen : "",
    isCollapsed ? styles.sidebarCollapsed : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      {mobileOpen && (
        <div
          className={styles.backdrop}
          onClick={onCloseMobile}
          aria-hidden="true"
        />
      )}

      <aside className={sidebarClasses}>
        <SidebarBrand
          isCollapsed={isCollapsed}
          onToggleCollapse={onToggleCollapse}
        />

        {propertyContext ? (
          <SidebarPropertyNav
            propertyContext={propertyContext}
            isCollapsed={isCollapsed}
            onCloseMobile={onCloseMobile}
          />
        ) : (
          <nav className={styles.navContainer} aria-label="Main Navigation">
            {visibleSections.map((section) => {
              // For single item: no category label required, render directly
              if (section.items.length === 1) {
                const singleItem = section.items[0];
                return (
                  <SidebarNavItem
                    key={singleItem.path}
                    item={singleItem}
                    isCollapsed={isCollapsed}
                    onNavigate={onCloseMobile}
                  />
                );
              }

              // For multi-item sections: render clean collapsible dropdown
              return (
                <SidebarDropdown
                  key={section.category}
                  section={section}
                  isCollapsed={isCollapsed}
                  onNavigate={onCloseMobile}
                />
              );
            })}
          </nav>
        )}

        <SidebarUserCard
          user={authUser}
          isCollapsed={isCollapsed}
          onOpenProfile={onOpenProfile}
          onLogoutClick={onLogoutClick}
        />
      </aside>
    </>
  );
};

export default Sidebar;
